var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},_vm._l((Array.from(Array(_vm.device.hoppersCount), (e,i)=> i + 1)),function(i){return _c('ProductsInHopperItem',{key:i,attrs:{"hopper-number":i,"device":_vm.device,"products":_vm.products},on:{"changed":(items) => _vm.$emit('changed', i, items)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }